import { getMsgDeskRuntime, type MsgDeskParams } from '@/msgdeskRuntime'
import { buildLegacyMsgRequestParams, type LegacyMsgRequestAction } from '@/msgdeskRuntime/legacyBridge/legacyRequestParams'

export const MSGDESK_MODEL_API_PATH = '/api/msgdesk/model'

export interface MsgDeskPhpModelResponse {
  ok: boolean;
  version?: number;
  kind?: string;
  request?: Record<string, unknown>;
  redirect?: { type?: string; url?: string } | null;
  model?: {
    main?: Record<string, unknown>;
    editor?: Record<string, unknown>;
    meta?: Record<string, unknown>;
    counts?: Record<string, unknown>;
    subs?: {
      answers?: Record<string, unknown>;
      submsges?: Record<string, unknown>;
    };
    settings?: Record<string, unknown>;
    body?: Record<string, unknown>;
    locked?: Record<string, unknown> | null;
    parent?: Record<string, unknown> | null;
  };
  legacy_html?: string | null;
  err?: string;
}

function buildMsgQuery(params: MsgDeskParams, action: LegacyMsgRequestAction): URLSearchParams {
  const runtime = getMsgDeskRuntime('template2')
  return buildLegacyMsgRequestParams(params, {
    action,
    isTestMode: runtime.isTestMode(),
    includeNextJs: action === 'get_msg',
  })
}

export async function fetchMsgHtml(params: MsgDeskParams): Promise<string> {
  const qs = buildMsgQuery(params, 'get_msg')

  const res = await fetch(`${MSGDESK_MODEL_API_PATH}?${qs}`)
  if (!res.ok) throw new Error(`HTTP ${res.status}`)
  return res.text()
}

export async function fetchMsgModel(params: MsgDeskParams): Promise<MsgDeskPhpModelResponse> {
  const qs = buildMsgQuery(params, 'get_msg_model')

  const res = await fetch(`${MSGDESK_MODEL_API_PATH}?${qs}`)
  const text = await res.text()
  if (!res.ok) throw new Error(`HTTP ${res.status}: ${text.slice(0, 200)}`)

  const payload = JSON.parse(text) as MsgDeskPhpModelResponse
  if (!payload.ok) throw new Error(payload.err || 'get_msg_model failed')
  return payload
}
